export const ALL_TYPES = {
  TOKEN: "TOKEN",
  INFO: "INFO",
  ARRAY_TESTS: "ARRAY_TESTS",
  STATUSES: "STATUSES",
  USER: "USER",
  USERS: "USERS",
};
